import styled from 'styled-components';

export const FeatureHeadingText = styled.p`
    font-size: 1.5rem;
    color: ${props => props.red? props.theme.redColor : props.theme.darkColor};
    font-weight: ${props => props.theme.boldWeight};
`